import React from 'react';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { ColorPalette } from '../config';
import { Box } from '../box';
import { CardComponent } from '../card-component';
import { AccordionLoader } from '../accordion/accordion-loader';

export interface IAreaSummaryBoxProps {
  children: React.ReactElement | React.ReactNode;
  isLoading?: boolean;
  noHorizontalPadding?: boolean;
  borderColor?: string;
  fullHeight?: boolean;
}

const useStyles = makeStyles<IAreaSummaryBoxProps>()((theme: Theme, props) => ({
  root: {
    fontSize: '.875rem',
    marginBottom: theme.spacing(1),
    position: 'relative',
    borderLeft: '5px solid',
    borderLeftColor: props.borderColor ?? ColorPalette.CityNightSkiesDark,
  },
}));

export function AreaSummaryBox(props: IAreaSummaryBoxProps) {
  const { children, isLoading = false, noHorizontalPadding, fullHeight } = props;
  const { classes } = useStyles(props);

  return (
    <CardComponent
      contentBackgroundColor={ColorPalette.WHITE}
      className={classes.root}
      noHorizontalPadding={noHorizontalPadding}
      fullHeight={fullHeight}
      data-vanguard="area-summary-box"
    >
      <AccordionLoader show={isLoading} />
      <Box display="flex" flexWrap="wrap">
        {children}
      </Box>
    </CardComponent>
  );
}
